import { Controller } from '@hotwired/stimulus';

export default class CertificateApplicationSummary extends Controller {
  static targets = [
    'totalQuantity',
    'totalAmount',
    'quantity',
    'isExpress',
    'deliveryCost',
    'expressCost',
    'englishName',
    'submit'
  ];

  connect() {
    this.update();
  }

  static values = {
    postAmounts: Array
  }

  update() {
    const quantities = this.quantityTargets.filter(quantity => Number(quantity.value) > 0);

    const totalQuantity = quantities.reduce((acc, quantity) => {
      return acc + Number(quantity.value);
    }, 0);

    const totalFees = quantities.reduce((acc, quantity) => {
      return acc + Number(quantity.dataset.amount) * Number(quantity.value);
    }, 0);

    const needEnglishName = quantities.some(quantity => {
      return quantity.dataset.needEnglishName === 'true';
    });

    const postage = this.#postage(totalQuantity, this.isExpressTarget.checked);

    this.englishNameTarget.disabled = !needEnglishName;
    this.submitTarget.disabled      = totalQuantity === 0;

    this.deliveryCostTarget.textContent  = Intl.NumberFormat('ja-JP').format(postage.delivery);
    this.expressCostTarget.textContent   = Intl.NumberFormat('ja-JP').format(postage.express);
    this.totalAmountTarget.textContent   = Intl.NumberFormat('ja-JP').format(totalFees + postage.delivery + postage.express);
    this.totalQuantityTarget.textContent = totalQuantity;
  }

  #postage(totalQuantity, isExpress) {
    if (totalQuantity === 0) {
      return { delivery: 0, express: 0 };
    }

    const postAmount = this.postAmountsValue.find(({lower_limit, upper_limit}) => lower_limit <= totalQuantity && totalQuantity <= upper_limit);

    return { delivery: postAmount.amount, express: isExpress ? postAmount.express_amount : 0 };
  }
}
